import React from 'react';
import { Bio } from '../../data/constants';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';
import './styles.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <a href="#hero" className="footer__logo">KS<span className="footer__logo-dot">.</span></a>

          <nav className="footer__nav">
            <a href="#experience">Experience</a>
            <a href="#skills">Skills</a>
            <a href="#projects">Projects</a>
            <a href="#education">Education</a>
            <a href="#contact">Contact</a>
          </nav>

          <div className="footer__socials">
            <a href={Bio.github} target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub /></a>
            <a href={Bio.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
            <a href={Bio.leetcode} target="_blank" rel="noreferrer" aria-label="LeetCode"><SiLeetcode /></a>
            <a href={Bio.twitter} target="_blank" rel="noreferrer" aria-label="Twitter"><FaTwitter /></a>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p className="footer__copy">
            &copy; {new Date().getFullYear()} Karthik Sagar Nallagula. All rights reserved.
          </p>
          <p className="footer__built">
            Built with React & lots of coffee.
          </p>
        </div>
      </div>
    </footer>
  );
}
